<script>
    import Button from "$lib/components/Button.svelte";
    import buyList from "$lib/json/shops.json";
	import { buyVisible } from "./states";
    // export let open = false;
</script>
{#await import("$lib/components/PopUp.svelte") then Module}
    {@const PopUp = Module.default}
    <PopUp on:close={()=>{buyVisible.set(false)}} open={$buyVisible}>
        <div class="buy">
            <div class="buy__left">
                <svg class="buy__logo" width="161" height="169" viewBox="0 0 58 60">
                    <use href="#logoPath"></use>
                </svg>
            </div>
            <div class="buy__right">
                <p class="buy__text">
                    Выберите магазин для покупки нашей продукции probaits
                </p>
                <div class="buy__list">
                    {#each buyList as shop}
                        <Button 
                            tag="a" 
                            href={shop.link} 
                            rel="nofollow, noreferrer" target="_blank"
                            styleType="fill hover-text-invert"
                            hover={shop.background}
                        >
                            {shop.label}
                        </Button>
                    {/each}
                </div>
            </div>
        </div>
    </PopUp>
{/await}

<style lang="postcss">
    .buy__logo{
        size: auto 3rem;
        margin: 0.25rem *;
    }
    .buy__left{
        display: none;
        /* text-align: center; */
    }
    .buy__right{
        text-align: center;
        padding: * * 1.5rem;
        background: var(--color-bg-0);
        color: var(--color-text);
        padding: 2.7143rem 0.83rem *;
    }
    .buy__text{
        margin-top: 0;
        font-size: 1.25rem;
        max-width: 21.8rem;
        letter-spacing: -0.0321rem;
    }
    .buy__list{
        font-size: 0.97rem;
        width: 14.3rem;
        display: grid;
        margin: * auto;
        gap: 1.1429rem;
        letter-spacing: normal;
        text-transform: uppercase;
        margin: * * 0.83rem;
    }
    @media (min-width:768px){
        .buy{
            display: flex;
        }
        .buy__text{
            font-size: 0.83rem; 
            letter-spacing: -0.02rem;
        }
        .buy__left{
            display: flex;
            align-items: center;
            justify-content: center;
            border-left-radius: 0.42rem;
            flex: 8.3rem 0 0;
            background: var(--color-text);
            color: var(--color-bg-0);
        }
        .buy__right{
            padding: 1.67rem 2.08rem 1.67rem 1.25rem;
        }
        .buy__logo{
            size: 6.7rem 7.05rem;
        }
        .buy__list{
            width: 8.5rem;
        }
        .buy__list{
            font-size: 0.66rem;
        }
    }
</style>